import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import PageTransition from '../components/layout/PageTransition';
import Reveal from '../components/ui/Reveal';
import Icon from '../components/ui/Icon';
import CTABanner from '../components/sections/CTABanner';
import { CASE_STUDIES } from '../data/site';

export default function WorkPage() {
  return (
    <PageTransition>
      <section className="page-hero">
        <div className="container">
          <Reveal><span className="eyebrow"><span className="dot" />Work</span></Reveal>
          <Reveal delay={0.06} as="h1">
            Work that shipped.<br />
            Numbers that <span className="serif gold">stuck</span>.
          </Reveal>
          <Reveal delay={0.12}>
            <p className="lede">
              A selection of recent engagements — AI agents, full-stack web, mobile, internal tools.
              Names and metrics shared with permission. Most of our best work isn't public.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="section--tight">
        <div className="container">
          <div className="work-grid">
            {CASE_STUDIES.map((c, i) => (
              <motion.article
                key={c.slug}
                className={'work-card' + (c.featured ? ' featured' : '')}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.16, 0.84, 0.44, 1] }}
              >
                <Link to="/contact" style={{ display: 'block', color: 'inherit' }}>
                  <div className="work-card__visual">
                    <div className="work-card__pattern" />
                    <div className="work-card__glyph">{c.glyph}</div>
                  </div>
                  <div className="work-card__body">
                    <div className="work-card__meta">
                      <span>{c.client}</span>
                      <span className="sep" />
                      <span>{c.industry}</span>
                      <span className="sep" />
                      <span>{c.year}</span>
                    </div>
                    <div className="work-card__title">{c.title}</div>
                    <p className="work-card__desc">{c.desc}</p>
                    <div className="work-card__tags">
                      {c.tags.map((t) => <span key={t} className="svc-detail__tag">{t}</span>)}
                    </div>
                  </div>
                </Link>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <Reveal>
            <div style={{ textAlign: 'center', maxWidth: 720, margin: '0 auto', padding: '64px 0' }}>
              <span className="eyebrow"><span className="dot" />Confidential engagements</span>
              <h2 style={{ marginTop: 18 }}>Most of our best work isn't on this page.</h2>
              <p className="lede" style={{ marginTop: 18, marginInline: 'auto' }}>
                Founders trust us with pre-launch products, sensitive infrastructure, and strategic
                bets. If you'd like to talk about something private, we'll come prepared and we'll
                stay quiet about it.
              </p>
              <div style={{ marginTop: 28, display: 'flex', justifyContent: 'center', gap: 12, flexWrap: 'wrap' }}>
                <Link className="btn btn--primary" to="/contact">
                  Request a private walkthrough <Icon name="arrow" size={14} className="arrow" />
                </Link>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <CTABanner />
    </PageTransition>
  );
}
